const StatusBadge = ({ status, onChange, isEditable = false }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'pending': return 'bg-yellow-100 text-yellow-800';
      case 'confirmed': return 'bg-blue-100 text-blue-800';
      case 'completed': return 'bg-green-100 text-green-800';
      case 'canceled': return 'bg-red-100 text-red-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  if (isEditable && onChange) {
    return (
      <select 
        value={status}
        onChange={(e) => onChange(e.target.value)}
        className={`text-sm border-0 rounded-full px-3 py-1 font-semibold focus:ring-2 focus:ring-blue-500 ${getStatusColor(status)}`}
      >
        <option value="pending">Pending</option>
        <option value="confirmed">Confirmed</option>
        <option value="completed">Completed</option>
        <option value="canceled">Canceled</option>
      </select>
    );
  }

  return (
    <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getStatusColor(status)}`}>
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </span>
  );
};

export default StatusBadge;